export default __webpack_public_path__ + "static/media/banner.3ed1fa96.png";